import { useEffect, useState } from 'react'

export interface SavedPdfTemplate {
  id: string
  name: string
}

/**
 * Die gespeicherten PDF-Vorlagen der Organisation fuer eine Vorlagenwahl (Konvertierung, E-Rechnung aus PDF).
 *
 * Bewusst ein direkter HTTP-Aufruf statt `trpc.pdf.templateList.useQuery`: ohne `pdf:template:read` zeigte der
 * globale Fehler-Handler von React Query sonst einen Toast — die Liste ist optional, eine Absage heisst „keine
 * Vorlagen". (Aus `InvoiceConversionPageWithProviders` herausgezogen, Verhalten unveraendert.)
 */
export function useSavedPdfTemplates(restBaseUrl: string): SavedPdfTemplate[] {
  const [templates, setTemplates] = useState<SavedPdfTemplate[]>([])
  useEffect(() => {
    const url = `${restBaseUrl}/trpc/pdf.templateList?input=${encodeURIComponent(JSON.stringify({ limit: 100, offset: 0, includeInactive: false }))}`
    fetch(url, { credentials: 'include' })
      .then((res) => (res.ok ? res.json() : null))
      .then((data) => {
        const list = (data?.result?.data?.templates || []).map((t: SavedPdfTemplate) => ({
          id: t.id,
          name: t.name,
        }))
        if (list.length > 0) setTemplates(list)
      })
      .catch(() => {
        // Silently ignore — template list is optional
      })
  }, [restBaseUrl])
  return templates
}
